"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OFFER_REGEN_BY_SLUG = exports.PACKAGE_TIER_SLUGS = void 0;
exports.highestActivePackageSlug = highestActivePackageSlug;
exports.defaultOfferRegenForSlug = defaultOfferRegenForSlug;
exports.formatMaxAiOffersLimit = formatMaxAiOffersLimit;
exports.formatOfferRegenLimit = formatOfferRegenLimit;
exports.packageAiLimitsLines = packageAiLimitsLines;
exports.resolvePackageAiLimitsFromCatalog = resolvePackageAiLimitsFromCatalog;
const package_features_1 = require("./package-features");
/** Σειρά «ισχύος» πακέτου για όρια AI (υψηλότερο κερδίζει). */
exports.PACKAGE_TIER_SLUGS = ['business', 'pro', 'basic'];
exports.DEFAULT_OFFER_REGEN_BY_SLUG = {
    basic: 4,
    pro: 15,
    business: 50,
    bronze: 15,
    silver: 15,
    gold: 50,
};
function highestActivePackageSlug(activeSlugs) {
    const normalized = activeSlugs.map(package_features_1.normalizePackageSlug);
    for (const slug of exports.PACKAGE_TIER_SLUGS) {
        if (normalized.includes(slug))
            return slug;
    }
    return 'basic';
}
function defaultOfferRegenForSlug(slug) {
    var _a;
    const normalized = (0, package_features_1.normalizePackageSlug)(slug);
    return (_a = exports.DEFAULT_OFFER_REGEN_BY_SLUG[normalized]) !== null && _a !== void 0 ? _a : exports.DEFAULT_OFFER_REGEN_BY_SLUG.basic;
}
function formatMaxAiOffersLimit(maxAiOffers) {
    if (maxAiOffers == null)
        return 'Απεριόριστες AI προσφορές';
    if (maxAiOffers === 1)
        return 'Έως 1 AI προσφορά';
    return `Έως ${maxAiOffers} AI προσφορές`;
}
function formatOfferRegenLimit(offerRegenLimit) {
    if (offerRegenLimit === 1) {
        return '1 επαναδημιουργία AI ανά προσφορά';
    }
    return `${offerRegenLimit} επαναδημιουργίες AI ανά προσφορά`;
}
/** Γραμμές για marketing / billing UI ανά πακέτο. */
function packageAiLimitsLines(limits) {
    return [
        formatMaxAiOffersLimit(limits.maxAiOffers),
        formatOfferRegenLimit(limits.offerRegenLimit),
    ];
}
function resolvePackageAiLimitsFromCatalog(catalog, activeSlugs) {
    var _a;
    const tierSlug = highestActivePackageSlug(activeSlugs);
    const pkg = (_a = catalog.find((p) => p.slug === tierSlug)) !== null && _a !== void 0 ? _a : catalog.find((p) => p.slug === 'basic');
    const fallbackRegen = defaultOfferRegenForSlug(tierSlug);
    const regenRaw = pkg === null || pkg === void 0 ? void 0 : pkg.offerRegenLimit;
    const offerRegenLimit = regenRaw != null && Number.isFinite(regenRaw) && regenRaw >= 0
        ? Math.min(10000, Math.floor(regenRaw))
        : fallbackRegen;
    const maxRaw = pkg === null || pkg === void 0 ? void 0 : pkg.maxAiOffers;
    const maxAiOffers = maxRaw == null
        ? null
        : Number.isFinite(maxRaw) && maxRaw >= 0
            ? Math.min(10000, Math.floor(maxRaw))
            : null;
    return { tierSlug, maxAiOffers, offerRegenLimit };
}
